<template>
    <div>
        <div class="row mb-3">
            <div class="col">
                <h6 class="card-title mb-1">{{ title }}</h6>
                
                <p v-if="firstDay" class="card-text"><em>{{ trai }}</em></p>
                <p v-if="lastDay" class="card-text"><em>{{ trao }}</em></p>

                <button v-if="isEditable && hasExcursion" 
                        class="btn btn-sm btn-danger float-right mx-1" :aria-label="removeButtonCaption"
                        @click="removeProduct(dayNumber, productType)">
                        {{ removeButtonCaption }}
                </button>
                <button v-if="isEditable && hasExcursion" 
                    class="btn btn-sm btn-warning float-right mx-1" :aria-label="changeButtonCaption"
                    @click="selectProduct(dayNumber, productType)(dayNumber, productType)">
                    {{ changeButtonCaption }}
                </button>
                <button v-if="isEditable && !hasExcursion" class="btn btn-sm btn-info float-right mx-1" 
                    @click="selectProduct(dayNumber, productType)" :aria-label="addButtonCaption">
                    {{ addButtonCaption }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from '../../main.js';
import { mapGetters } from 'vuex';

export default {
    props: {
        excursion: { type: Object, default: null },
        dayNumber: { type: Number, requried: true },
        lastDay: { type: Boolean, required: true },
        readOnly: { type: Boolean, default: false }
    },
    data() {
        return {
            addButtonCaption: 'Add Daytime Activity',
            changeButtonCaption: 'Change',
            removeButtonCaption: 'Remove',
        }
    },
    computed: {
        ...mapGetters( [ 'getTransferIn', 'getTransferOut' ]),
        productType() { return 'Excursion' },
        firstDay() { return this.dayNumber == 1; },
        trai() { return this.getTransferIn },
        trao() { return this.getTransferOut },
        title() {
            if (this.firstDay) {
                return 'Arrive in Ireland';
            } else if (this.lastDay) {
                return 'Departure Day';
            }

            return this.excursion != null ? this.excursion.title : 'Day at Leisure';
        },
        isEditable() {
            return !this.readOnly && !this.firstDay && !this.lastDay;
        },
        hasExcursion() {
            return this.excursion != null;
        }
    },
    methods: {
        selectProduct(dayNo, productType) {
            eventBus.selectProduct(dayNo, productType);
        },
        removeProduct(dayNo, productType) {
            this.$store.dispatch('removeProduct', { dayNo, productType });
        }
    }
}
</script>